import { SiteHeader } from './SiteLayout';

// The website's header across the top of every app page (calendar, results,
// portals ...), so the menu is the same on every NHCA page. The public
// website's own pages get it from SiteLayout.
//
// Hidden when the page is shown inside a frame, where the host page already
// has its own navigation.

function inFrame() {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}

export default function AppBar() {
  if (inFrame()) return null;
  return (
    <div className="site site--bar">
      <SiteHeader />
    </div>
  );
}
